import React from 'react';

import styled from 'styled-components';
import {
  Contents,
  DropdownMenu,
} from 'view/components';
import CloseIcon from "../../../../assets/images/icon/CloseIcon";
import {useSetRecoilState} from "recoil";
import {Alert} from "../../../../state";

interface PopupProps{
    onChange:any,
    value:string,
    onClick:any
}

const CreatePopup = (props) => {
    const setAlert = useSetRecoilState(Alert)
    const onKeyDown = (e) => {
        if(e.keyCode === 13){
            if(props?.value.length < 10){
                if(props?.value.length == 0) {
                    setAlert({
                        isActive:true,
                        text:"Please enter a title to proceed.",
                        desc:"Enter a title",
                        type:"info",
                        color:"blue",
                        time:1300
                    })
                }else {
                    setAlert({
                        isActive:true,
                        text:"The number of characters in the title must be between 10 and 70",
                        desc:"",
                        type:"warn",
                        color:"yellow",
                        time: 1300
                    })
                }

            }else{
                props?.onClick()
            }
        }
    };
    return (
        <Container>
            <Contents
                title={"Coaching Setup"}
                className={"popup"}
            >
                <div className="closeIcon">
                    <CloseIcon/>
                </div>
                <Inner
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >

                    <h1>Let's get started: Title and Class</h1>
                    <FormBoxItemWrap>
                        <li>
                            <span style={{marginBottom: 10}}>Class <strong>*</strong></span>
                            <p>Select the class where this coaching belongs.</p>
                            <FormItem>
                                <DropdownMenu
                                    selected={props?.selectClass?.classTitle || ""}
                                    altText="All classes"
                                    onClick={props?.onClickDropdown}
                                    items={props?.classList || []}/>
                            </FormItem>
                        </li>
                        <li>
                            <span style={{marginBottom: 10}}>Title <strong>*</strong></span>
                            <p>It’s ok if you can’t think of a good title now. You can change it later</p>
                            <FormItem>
                                <input
                                    onChange={props?.onChange}
                                    type="text"
                                    value={props?.value}
                                    placeholder="Enter a title"
                                    maxLength={100}
                                    onKeyDown={onKeyDown}
                                />
                                <TextLength>
                                    {100 - props?.value?.length}
                                </TextLength>
                            </FormItem>
                        </li>
                    </FormBoxItemWrap>
                    <Continue
                        onClick={() => {
                            if(props?.value.length < 10){
                                if(props?.value.length == 0) {
                                    setAlert({
                                        isActive:true,
                                        text:"Please enter a title to proceed.",
                                        desc:"Enter a title",
                                        type:"info",
                                        color:"blue",
                                        time: 1300,
                                    })
                                }else {
                                    setAlert({
                                        isActive:true,
                                        text:"The number of characters in the title must be between 10 and 70",
                                        desc:"",
                                        type:"warn",
                                        color:"yellow",
                                        time: 1300
                                    })
                                }

                            }else{
                                props?.onClick()
                            }
                        }}>
                        <span>Continue</span>
                    </Continue>
                </Inner>
            </Contents>
        </Container>
    );
};
export default CreatePopup;

const Container = styled.div`
    @media screen and (max-width: 768px) {
        margin: 0 auto;
        width: 95%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        
    }
    @supports (-webkit-touch-callout: none) {
        top: 40%;
        
    }
    .closeIcon{
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 10px;
        transition: all 0.2s;
        svg{
            width: 30px;
            height: 30px;
        }
        &:hover{
            transform: scale(1.1);
        }
    }
    h1 {
        font-size: 28px;
        font-weight: 700;
        color: #333;
        margin-bottom: 30px;
        font-family: "Source Serif 4", serif;
    }
`;
const Inner = styled.div`
    @media screen and (max-width: 768px) {
        width: 100%;
        
    }
    
    padding: 30px 40px 40px 40px;
    width: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    p {
        font-size: 18px;
        font-weight: 400;
    }
`;
const FormBoxItemWrap = styled.ul`
    width: 100%;
    margin-bottom: 15px;
    > li {
        
        font-size: 16px;
        margin-bottom: 15px;
        span{
            display: flex;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: 0em;
            text-align: left;
            color: #333333;
            strong{
                font-size: 13px;
                color: #DA1414;
            }
        }
        p{
            margin-bottom: 10px;
            color: #333;
            font-family: "Europa-Regular";
            font-size: 15.3px;
            font-style: normal;
            font-weight: 400;
            line-height: 20px;
            margin-bottom: 10px;
        }
    }
`;

const FormItem = styled.div`
    position: relative;
    > input[type="text"],
    select,
    textarea {
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 12px;
`;

const Continue = styled.div`
    padding: 10px 30px;
    border-radius: 6px;
    border: solid 1px #333;
    cursor: pointer;
    box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.08);
    background-color: #fff;
    &:hover{
        background: #333;
        span {
            color: #fff;
        }
    }
    span{
        font-size: 18px;
        font-weight: 400;
        color: #333;
    }
`; 